import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import DisabledComment from '../../../DisabledComment';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import s from './DisabledOrPrivateInfo.scss';
/** What we will display if a logged in user is unable to comment on a post for any reason. */ export const DisabledOrPrivateInfo = ({ commentsDisabledForAllUsers = true, isPaidFolder, user, authorName, subproductId })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    if (commentsDisabledForAllUsers) {
        return /*#__PURE__*/ React.createElement(DisabledComment, {
            title: t('commentbox.disabled')
        });
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !isMobile && /*#__PURE__*/ React.createElement(UserAvatar, {
        user: user,
        size: 50,
        className: s['avatar'],
        withLink: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, isPaidFolder ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PremiumGallery, {
        size: IconSize.SMALL,
        className: s['icon']
    }), /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "commentbox.paywall.premiumFolders.locked",
        parent: "span"
    }, /*#__PURE__*/ React.createElement(BiLink, {
        href: subproductId ? Url.checkoutLink(subproductId) : undefined,
        className: s.link,
        biData: BiData({
            evid: 2,
            click_info: 'comment_unlock_paid_folder',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    }, 'Unlock'), " the artist's premium folder to join the discussion.")) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EyeDisc2, {
        size: IconSize.SMALL,
        className: s['icon']
    }), /*#__PURE__*/ React.createElement("span", null, t('commentbox.paywall.watchersFolders.locked', {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        author: /*#__PURE__*/ React.createElement("span", null, authorName)
    })))));
};
DisabledOrPrivateInfo.displayName = 'DisabledOrPrivateInfo';
export default DisabledOrPrivateInfo;
